import * as Vest from 'vest';
import 'vest/enforce/compounds';
import { DateTime as LuxonDateTime} from 'luxon';
import dayjs, { Dayjs } from 'dayjs';


function validateDateFormat(dt:Date): boolean {
    let d2 = dt.toISOString();
    return(LuxonDateTime.fromISO(d2).isValid)
  }

function validateDateRange(dt_end:Dayjs, dt_start:Dayjs){
    if(dt_end > dt_start)
    {
        return true;
    }
    else{
        return false;
    }
}

export const FormSuite = Vest.create((data = {}) => {
 
    Vest.test('date_start','ERROR_FORMAT_DDMMYYYY', () => {
        return validateDateFormat(data.date_start);
    });

    Vest.test('date_end','ERROR_FORMAT_DDMMYYYY', () => {
        return validateDateFormat(data.date_end);
    });

    Vest.test('date_end','BAD_DATES_LOAD', () => {
        return validateDateRange(data.date_end, data.date_start);
    });
});